
















































































import Vue from 'vue';
import NOC from '@/class/common/const';
import * as models from '@/class/models/views/account';

export default Vue.extend({
  name: 'Invoice',
  data() {
    return {
      data: {} as models.VInvoice,
      ZEINUKI: 100,
      ZEIRITSU: 0.1, // 10%
      targetAmount: 0,
      tookOverAmount: 0,
      zeinukiAmount: 0,
    };
  },
  computed: {
    NOTIFICATION() {
      return NOC.NOTIFICATION;
    },
  },
  mounted() {
    const storage = localStorage.getItem('/Invoice');
    if (storage) {
      const tempData = JSON.parse(storage) as models.VInvoice;
      this.targetAmount = tempData.messageValues.targetClientCount * this.ZEINUKI;
      this.zeinukiAmount = this.targetAmount;
      if (tempData.messageValues.tookOverYear > 0) {
        this.tookOverAmount = tempData.messageValues.tookOverClientCount * this.ZEINUKI;
        this.zeinukiAmount += this.tookOverAmount;
      }
      this.data = tempData;
      localStorage.removeItem('/Invoice');
      // 印刷用グローバルCSSを他の画面に影響しないように、ここだけはhtmlタグにクラス名追加
      document.documentElement.classList.add('html-invoice-mail');
    } else {
      window.close();
      this.$router.replace('/');
    }
  },
});
